module.exports = __webpack_public_path__ + "img/logo2.081556b0.jpg";